export default __webpack_public_path__ + "ed4b9574f9467b02dd1b4135e9f87fe6.png";